import React, { useState, useEffect, useCallback, useRef } from "react";
import { useIntl } from "react-intl";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";

//
import ImageUploadApi from "Services/ImageUpload";
import driverApi from "Services/Driver";

//
import { CUSTOM_CONSTANTS } from "Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewDriverDetails = (props) => {
  const classes = useStyles();
  const intl = useIntl();
  const t = intl.formatMessage;
  const dispatch = useDispatch();
  const { openDialog, handleClose, driverId, setCloseAllTabs } = props;

  const [data, setData] = useState([]);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsRow, setDocumentsRow] = useState([]);
   const [documentsInitialData, setDocumentsInitialData] = useState([]);
  //

  const handleCloseTabs = () => {
    dispatch(
      showSnackbar({
        message: t({ id: "driver.modal.update.success" }),
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      })
    );

    handleClose();
    setCloseAllTabs(true);
  };

  //

  const getDriverCompleteDetails = () => {
    dispatch(showLoader(t({ id: "driver.loading" })));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        showSnackbar({
          message: t({ id: "driver.preview.fetchSuccess" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        });
        setData(res?.data?.data);
        setDriverDocumentsData(res?.data?.data?.driverDocumentsDetails);
       
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: t({ id: "driver.preview.fetchError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    if (validation) {
      driverApi
        .getDriverCompleteDetailsByDId(driverId)
        .then(onSuccess, onFailure);
    }
  };

  const getDriverDocumentsTypes = () => {
    dispatch(showLoader(t({ id: "driver.loading" })));
  
    const onSuccess = (res) => {
      dispatch(hideLoader());
  
      if (res?.status === 200) {
        console.log(res?.data?.data);
        setDocumentsInitialData(res?.data?.data)
     
      }
    };
  
    const onFailure = (err) => {
      dispatch(hideLoader());
  
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || t({ id: "driver.fetchError" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
  
      console.log("error fetch service area", err);
    };
  
    driverApi.getDocumentsTypes().then(onSuccess).catch(onFailure);
  };

  useEffect(() => {
    setData([]);
    setDriverDocumentsData([]);
    getDriverCompleteDetails();
    getDriverDocumentsTypes();
  }, [openDialog]);

  useEffect(() => {
    const combinedArray = documentsInitialData.map((item1) => {
      const matchingDocument = driverDocumentsData.find((item2) => {
        return (
          item1?.documentType
            ?.toLowerCase()
            ?.replace(/[()]/g, "")
            ?.replace(/-/g, " ")
            ?.replace(/\s+/g, " ")
            ?.trim() ===
          item2?.documentType
            ?.toLowerCase()
            ?.replace(/[()]/g, "")
            ?.replace(/-/g, " ")
            ?.replace(/\s+/g, " ")
            ?.trim()
        );;
      });
      console.log(documentsInitialData)
      console.log(driverDocumentsData)
const documentId =matchingDocument && matchingDocument.documentPath !== "" ? t({ id: "driver.preview.uploaded" }) : t({ id: "driver.preview.notUploaded" });
const documentPath = matchingDocument ? matchingDocument.documentPath  : "-";
const status = matchingDocument ? matchingDocument.documentPath ? matchingDocument.status : t({ id: "driver.preview.noDocument" }): t({ id: "driver.preview.noDocument" });
const uploadedDocumentName = matchingDocument? matchingDocument?.uploadedDocumentName: "-";

      return {
        ...item1,
        documentId,
        file: documentPath,
        status,
        uploadedDocumentName,
      };
    });

    setDocumentsRow(combinedArray);
  }, [driverDocumentsData]);

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"md"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              {t({ id: "driver.preview.title" })}
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <div className={classes.driverContainer}>
              <div className={classes.driverImage}>
                <img
                  src={data?.driverInfoDetails?.image ||"/assets/images/user/avatar.png"}
                  alt="Profile Image"
                  className={classes.profileImage}
                />
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>{t({ id: "driver.preview.basicInfo" })}</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.username" })}</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.userName}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.countryCode" })}</div>
                  {data?.driverInfoDetails?.countryCode}
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.mobileNumber" })}</div>
                  {data?.driverInfoDetails?.mobileNumber}
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.email" })}</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.email}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.gender" })}</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.gender}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.country" })}</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.country}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.address" })}</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.address}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.bankAccount" })}</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.bankAccountNumber}
                  </div>
                </div>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>{t({ id: "driver.preview.serviceDetails" })}</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.service" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.serviceTypeId?.serviceName}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.serviceType" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.serviceKind}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.vehicleNumber" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.vehicleModel" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleModel}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.licenseNumber" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.driverLicenseNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.licenseExpiry" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.licenseExpiryDate}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.insuranceNumber" })}</div>

                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleInsuranceNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.insuranceExpiry" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.insuranceExpiryDate}
                  </div>
                </div>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>{t({ id: "driver.preview.driverDocuments" })}</h2>
                <table className={classes.table}>
                  <thead className={classes.tableHeader}>
                    <tr>
                      <th className={classes.tableCell}>{t({ id: "driver.preview.docType" })}</th>
                      <th className={classes.tableCell}>{t({ id: "driver.preview.docStatus" })}</th>
                      <th className={classes.tableCell}>{t({ id: "driver.preview.approvalStatus" })}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentsRow.map((document, index) => (
                      <tr key={index} className={classes.tableRow}>
                        <td className={classes.tableCell}>
                          {document?.documentType}
                        </td>
                        
                        <td className={classes.tableCell}>
                          {document.documentId}
                        </td>
                        <td className={classes.tableCell}>{document.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>{t({ id: "driver.preview.accountStatus" })}</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.accountStatusLabel" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.accountStatus === "ONBOARDING"
                      ? t({ id: "driver.preview.onboarding" })
                      : data?.driverServiceDetails?.accountStatus === "APPROVED"
                      ? t({ id: "driver.preview.approved" })
                      : data?.driverServiceDetails?.accountStatus === "BANNED"
                      ? t({ id: "driver.preview.banned" })
                      : ""}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>{t({ id: "driver.preview.driverStatus" })}</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.driverAccountStatus ===
                    "ACTIVE"
                      ? t({ id: "driver.preview.active" })
                      : data?.driverServiceDetails?.driverAccountStatus ===
                        "DE_ACTIVE"
                      ? t({ id: "driver.preview.deactive" })
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose} style={{ marginRight: "10px" }}>
                {t({ id: "driver.preview.backToEdit" })}
              </Button>
            </section>
            <section className={classes.closeBtn}>
              <Button onClick={handleCloseTabs} style={{ marginRight: "10px" }}>
                {t({ id: "driver.preview.confirmClose" })}
              </Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreviewDriverDetails;
